import { PostHogEvent } from "@/posthog/posthog-capture-names";
import { PosthogHelper } from "@/posthog/posthog-helper";
import posthog from "posthog-js";
import { useAccountEffect } from "wagmi";

export function ConnectWalletAnalytics() {
    useAccountEffect({
        onConnect({ address }) {
            // TODO: Add analytics for connected wallet
            if (posthog.has_opted_in_capturing()) {
                PosthogHelper.capture({
                    event_name: PostHogEvent.Wallet.connected,
                    properties: {
                        walletAddress: address,
                    },
                    userIdentifier: address,
                    allowTemporaryOptIn: false,
                });
            }
        },
    });

    return null;
}
